<script>
    import {res, prefs, ui, state, live} from './stores.js';
    import { getDashboard, getIconURL, getShipCode } from './card_images.js';
    import { missionComplete, checkMission } from './parse.js';
    import { completeMission, mustPlayManual } from './card_actions.js';
    import { waiting, isTouchDevice, select, convert, debounce } from './ui.js';
    import { doAction, getCard } from './game.js';
    import tippy from 'tippy.js';
    import 'tippy.js/dist/tippy.css'; // optional for styling
    import MissionStatus from './MissionStatus.svelte';
    import { getTraitTicks} from './khan.js';

    export let p;
    export let preview = false;
    export let height = `${$res.cardWidth * $prefs.cardScale * 3 / 1795 * 1193}vmin`;
    export let width = `${$res.cardWidth * $prefs.cardScale * 3 / (preview ? 2 : 1)}vmin`;
    export let hide = false;
    let actionElement;
    let missElement = Array(3);
    let tip;
    let tipNum = -1;

    let image = getDashboard(p);
    if(image == '') image = false;

    //$: debouncedStatus($state);
    // TODO aspect ratio correct – take it from image itself...

    //if(preview) width = `${$res.cardWidth * $prefs.cardScale * 3 / 2}vmin`;

    let trackData = {
        'military': {
            offset: 1.54
        },
        'research': {
            offset: 7.7
        },
        'influence': {
            offset: 2.58
        }
    }

    function selectingMissions(ui){
        if(waiting() == 'cards' && ui.waiting[0].cards.some(c => c.suits.includes('mission'))) return true;
        return false;
    }

    function hover(e, type){
        if(isTouchDevice()) return;
        //console.log('hover', preview)
        if(!preview){
            $live.previewDashboard = p;
            $live.dashboardArea = type;
        }
        $live.shouldHideDashboard = false;
    }

    function unhover(e){
        //console.log('unhovering', $ui.dashboardSelected, $ui.previewDashboard)
        if(isTouchDevice()) return;
        if(!$ui.dashboardSelected && $live.previewDashboard == p){
            //
            $live.shouldHideDashboard = {x: e.clientX, y: e.clientY};
            //$ui.previewDashboard = null;
        }
    }

    function click(type){
        //console.log('clicked', type, $ui.previewDashboard, $live.dashboardArea)
        if($ui.dashboardSelected == p && $live.dashboardArea == type){
            $live.previewDashboard = false;
            $ui.dashboardSelected = false;
        }else{
            $live.previewDashboard = p;
            $live.dashboardArea = type;
            $ui.dashboardSelected = p;
            //console.log('selected')
        }
    }

    function clickMission(e, m){
        if($ui.selection != m){
            $ui.selection = m;
            $live.previewDashboard = p;
            $live.dashboardArea = 'mission';
        }else{
            $ui.selection = null;
            $live.previewDashboard = false;
        }
        console.log($ui.selection, $res.parsedCardText[m.id], checkMission(p, m))
        e.stopPropagation();
    }

    $: if(!hide && $ui.selection && p.dashboard.missions.some(m => m == $ui.selection)){
        let i = p.dashboard.missions.findIndex(m => m == $ui.selection)
        //console.log('show', hide, $ui.selection, p.dashboard.missions, p.dashboard.missions.some(m => m == $ui.selection))
        if(tipNum != i){
            if(tip){
                tip.hide();
                tip.destroy();
            }
            if(missElement[i] && !hide && !preview){
                tip = tippy(missElement[i], {
                    content: actionElement,
                    trigger: 'manual',
                    interactive: true,
                    appendTo: document.body,
                    maxWidth: 'none'
                })  
                tipNum = i;
            }
            if(tip) tip.show();
        }
        
    }else if(!hide && (!$ui.selection || !p.dashboard.missions.some(m => m == $ui.selection))){
        //console.log('hide', hide, $ui.selection,  p.dashboard.missions, p.dashboard.missions.some(m => m == $ui.selection))
        if(tip){
            tip.hide();
            tip.destroy();
            tip = null;
            tipNum = -1;
        }
    }
</script>

    <div class="dashboard" class:selected={$ui.dashboardSelected == p && !preview} class:preview={preview} style="aspect-ratio: 1795 / 1193; width: {width}; {image && $prefs.useCardImages ? `background-image: url(${image});` : (p.captain != 'Khan' ? `background-image: url(links/card-template-dashboard.png)` : '')}" 
    
     />
    <div class="trackhover" style="top: 0; left: 0; width: calc({width} - calc({height} / 1.43)); height: {height};" 
        on:mouseenter={e => {hover(e, 'track')}}
        on:mousemove={e => {hover(e, 'track')}}
        on:mouseleave={unhover} 
        on:click={e => {if(!preview && !isTouchDevice()) click('track'); } } 
        on:touchstart={e => {if(!preview && isTouchDevice()) click('track'); } } 
    />
    {#if !preview || preview == 'track'}
        {#if p.captain != 'Khan'}
            {#if !image || !$prefs.useCardImages}
                <div class="captain" style="font-size: {0.6 * (preview ? 2 : 1)}em;">{p.captain.toUpperCase()} ({p.dashSide.toUpperCase()})</div>
                {#each $res.trackTypes as t}
                    {#each Array(16) as a, i}
                        {#if p.dashboard[t][i]}
                            <div class="track marker" style="height: calc({height} / 20); left: calc({height} / {trackData[t].offset} + {preview ? 4 : 2.5}vmin); width: calc({height} / 9); bottom: calc({height} / 17 + calc({height} / 21 * {i})); font-size: calc({height} / 25);">
                                x{p.dashboard[t][i]}
                            </div>
                        {/if}
                    {/each}
                {/each}
            {/if}
            {#each $res.trackTypes as t}
                <div class="track {t}" style="height: calc({height} / 20); left: calc({height} / {trackData[t].offset}); width: calc({height} / 9); bottom: calc({height} / 17 + calc({height} / 21 * {p[t]})); font-size: calc({height} / 25);">
                    {p[t]}
                </div>
            {/each}
        {:else}
            <div class="captain" style="font-size: {0.5 * (preview ? 2 : 1)}em;">{p.captain.toUpperCase()} ({p.dashSide.toUpperCase()})</div>
            <div class="khan" style="font-size: {0.5 * (preview ? 2 : 1)}em;">
                <div>
                    {@html convert(`When you gain a card or take control of a neutral [[location]] that has one or more of the following traits, you may mark *one* of them as collected:`, true)}
                </div>
                <div class="khan_list">
                    {#each getTraitTicks(p, $state) as t}
                        <div>
                            {#if t.ticked}✅{:else}🔲{/if}
                            {@html convert(t.text, true)}
                        </div>
                    {/each}
                </div>
            </div>
        {/if}
    {/if}
    {#if p.dashboard}
        {#if !preview || preview == 'mission'}
            {#each p.dashboard.missions as m, i}
                <div class="mission" bind:this={missElement[i]} class:clickable={selectingMissions($ui)} class:selected={$ui.selection == m} style="left: calc({height} / 1.25); width: calc({height} / 1.43); top: calc({height} / 3.2 * {i}); height: calc({height} / 3.2);"
                on:mouseenter={e => {hover(e, 'mission')}}
                on:mousemove={e => {hover(e, 'mission')}}
                on:mouseleave={unhover} 
                on:click={e => {if(!isTouchDevice()) clickMission(e, m);}}
                on:touchstart={e => {if(isTouchDevice()) clickMission(e, m);}}
                >
                <!-- ships and completeness-->
                <div class="container">
                    {#if !image || !$prefs.useCardImages} <!-- i.e. no image-->
                        <div class="mission_name" style="font-size: {1 * (preview ? 2 : 1)}vmin;">{m.name}</div>
                        <div class="mission_text" style="font-size: {0.7 * (preview ? 2.5 : 1)}vmin; gap: {0.2 * (preview ? 2 : 1)}vmin;">
                            <div class="mission_goal">{@html convert(m.goal, true)}</div>
                            <div class="mission_reward">{@html convert(m.reward, true)}</div>
                        </div>
                        <div class="mission_vp" style="font-size: {2 * (preview ? 2 : 1)}vmin;">{m.vp}</div>
                    {/if}
                    <div class="status" style="font-size: {$prefs.buttonScale * 2}vmin;">
                        {#if m.complete}
                            ✅
                        {:else if missionComplete(m, p) == 'ready'}
                            👉
                        {/if}
                    </div>
                    {#if m && m.orbiting}
                        <div class="ships" style="{$ui.seat != 0 ? '--ship_colour: pink;' : '--ship_colour: lightblue;'}">
                            {#each m.orbiting as o (getShipCode(o.card, o.ship)) }
                                <img transition:blur|global on:click={e => {select(getCard(o.card), false)}} class="image_ship ship" src={getIconURL(o.ship)} />
                            {/each}
                        </div>
                    {/if}
                    {#if mustPlayManual(m)}
                        <div class="auto_marker">🤚</div>
                    {/if}
                    {#if m.status && !m.complete }
                        <div class="progress_meter">
                            {#each Array(m.status.count > 0 ? m.status.count : 0) as _}
                                <div class="progress_element progress_done" style="filter:hue-rotate(-{(100-m.status.percent)/100*90}deg);"/>
                            {/each}
                            {#each Array(m.status.left > 0 ? m.status.left : 0) as _}
                                <div class="progress_element progress_not_done" />
                            {/each}
                        </div>
                    {/if}
                </div>
                </div>
            {/each}
        {/if}   
    {/if}
    <div style="display: none;">
        <div bind:this={actionElement} class="mission_actions">
            {#if !hide && $ui.selection && p.dashboard.missions.some(m => m == $ui.selection) && !$ui.selection.complete}
                <MissionStatus m={$ui.selection} status={$ui.selection.status}/><!--status={checkMission(p, $ui.selection)}/>-->
            {/if}
        </div>
    </div>

<style>
    .mission_actions {
        display: flex;
        flex-direction: column;
        align-items: center;
        max-width: 50vw;
    }
    .status {
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 50%;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .clickable {
        pointer-events: all;
        background-color: rgba(0, 255, 0, 0.2);
        border: 1px dashed orange;
    }
    .selected {
        border: 5px dashed orange;
        filter: saturate(3);
        box-sizing: border-box;
    }
    .container {
        position: relative;
        width: 100%;
        height: 100%;
    }
    .auto_marker {
        position: absolute;
        top: 0;
        left: 0;
        opacity: 0.9;
    }

    .ships {
        position: absolute;
        bottom: 0;
        right: 0;
        width: 100%;
        height: 50%;
        display: flex;
        justify-content: flex-end;
        align-items: center;
    }
    .value_image {
        object-fit: contain;
        height: 100%;
        width: 100%;
    }
    .mission {
        position: absolute;
        /*border: 2px solid black;
        color: grey;*/
    }
    .khan {
        position: absolute;
        top: 10%;
        left: 5%;
        width: 45%;
        height: 80%;
        color: black;
        pointer-events: none;
    }
    .khan_list {
        columns: 2;
    }
    .track {
        position: absolute;
        width: 7.5%;
        height: 5%;
        border-radius: 40%;
        border: 1px solid black;
        color: white;
        text-shadow: -1px -1px 0 black, 1px -1px 0 black, -1px 1px 0 black, 1px 1px 0 black;
        text-align: center;
        font-weight: bold;
    }
    .marker {
        border: unset;
        border-radius: unset;
        font-weight: bold;
        font-size: 10%;
        text-shadow: -1px -1px 0 black, 1px -1px 0 black, -1px 1px 0 black, 1px 1px 0 black;
        color: lightblue;
        background-image: url(vp-positive.png);
        background-size: cover;
        background-position: center;
        background-repeat: no-repeat;
    }
    .military {
        background-color: red;
    }
    .influence {
        background-color: yellow;
    }
    .research {
        background-color: blue;
    }
    .dashboard {
        object-fit: contain;
        background-color: white;
        background-size: contain;
        background-repeat: norepeat;
        background-position: center;
    }

    .preview {
        opacity: 0.9;
        pointer-events: none;
    }

    .image_ship {
        object-fit: contain;
        object-position: right;
        height: 75%;
        width: 75%;
        pointer-events: all;
        cursor: pointer;
    }
    .ship {
        /*filter: drop-shadow(5px 5px 10px blue);
        box-shadow: 0 0 10px 5px red;*/
        filter: drop-shadow(1px 1px var(--ship_colour)) drop-shadow(1px -1px var(--ship_colour)) drop-shadow(-1px 1px var(--ship_colour)) drop-shadow(-1px -1px var(--ship_colour))
    }

    .trackhover {
        /*background-color: rgb(20,20,20,0.5);*/
        position: absolute;
    }

    .progress_meter {
        width: 100%;
        height: 1vmin;
        display: flex;
        flex-wrap: nowrap;
        position: absolute;
        bottom: 0;
        opacity: 80%;
    }

    .progress_element {
        border: 0.1px solid black;
        width: 100%;
    }

    .progress_done {
        background-color: green;
        
    }

    .progress_element + .progress_element {
        border-left: none;
    }

    .progress_not_done {
        background-color: white;
    }

    .captain {
        position: absolute;
        top: 0;
        left: 0;
        font-size: 3vmin;
        text-shadow: -1px -1px 0 black, 1px -1px 0 black, -1px 1px 0 black, 1px 1px 0 black;
        color: orange;
    }
    .mission_name {
        position: absolute;
        top: 3%;
        left: 20%;
        width: 80%;
        text-align: center;
        font-weight: bold;
        font-size: 5%;
        text-shadow: -1px -1px 0 black, 1px -1px 0 black, -1px 1px 0 black, 1px 1px 0 black;
        color: #9496CA;
    }
    .mission_text {
        position: absolute;
        top: 20%;
        left: 20%;
        width: 80%;
        height: 80%;
        text-align: left;
        font-size: 3%;
        color: black;
        display: flex;
        flex-direction: column;
    }
    .mission_goal {
        /*position: absolute;
        top: 20%;
        left: 20%;
        width: 80%;
        height: 40%;
        text-align: left;
        font-size: 3%;*/
        color: black;
        background-color: #CA9AC5;
    }
    .mission_reward {
        /*position: absolute;
        top: 60%;
        left: 20%;
        width: 80%;
        height: 40%;
        text-align: left;
        font-size: 3%;*/
        color: black;
        background-color: #F79768;
    }
    .mission_vp {
        position: absolute;
        bottom: 10%;
        left: 0;
        width: 15%;
        height: 40%;
        text-align: right;
        font-weight: bold;
        font-size: 10%;
        text-shadow: -1px -1px 0 black, 1px -1px 0 black, -1px 1px 0 black, 1px 1px 0 black;
        color: lightblue;
        background-image: url(vp-positive.png);
        background-size: cover;
        background-position: center;
        background-repeat: no-repeat;
    }
</style>